import "../editorStyleSheet.css"
import BodyComponents from "./BodyComponents";
import PropTypes from "prop-types";
import {regenerateAudioPerPage, rerunService, updatePagesDataByArticleId} from "../../../axios-client";
import {useEffect, useState, useCallback, useRef} from "react";
import DigitizationMarkdownComponent from "./editorDigitizationContent/DigitizationMarkdownComponent";
import { useTranslation } from "react-i18next";

const EditorBodyComponent = ({
    handleFullScreen,
    isFullScreen,
    mediaPath,
    containerWidth,
    forcePageNumber,
    numPages,
    pageNumber,
    setForcePageNumber,
    configWidth,
    updateConfigWidth,
    page,
    pages,
    fileName,
    sourceLanguage,
    targetLanguage,
    articleId,
    digitizationId,
    setNotification,
    setPage,
    bookmarkingSelected,
    translationSelected,
    setUpdatePages,
    updatedPages,
    fetchData
}) => {
    const [zoom, setZoom] = useState(0.3);
    const [isProcessing, setIsProcessing] = useState(false)
    const { t } = useTranslation(['editor']);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (updatedPages?.length > 0) {
                const message = "You have unsaved changes, are you sure you want to leave?";
                e.returnValue = message;
                return message;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [updatedPages]);

    const addOrUpdatePages = (num, data , field) => {

        setUpdatePages(prevTexts => {
            const existingText = prevTexts.find(item => item.num === num);

            if (existingText) {
                return prevTexts.map(item =>
                    item.num === num ? { ...item, [field]: data } : item
                );
            } else {
                return [...prevTexts, { num, [field]: data }];
            }
        });
    };

    const updateAudioPaths = (audioList) => {
        const matchingAudio = audioList.find(audio => audio.num === page.num);

        setPage({
            ...page,
            audio_path: matchingAudio.audio_path
        })
    };

    const regenerateBookmarking = () => {
        rerunService(digitizationId, {service_name: 'Bookmarking'})
            .then(() => {
                setNotification({ show: true, snackbarMessage: 'Regenerating Bookmarking in progress', severity: 'success' });
            })
            .catch(e => {
                setNotification({ show: true, snackbarMessage: 'An unexpected error occurred', severity: 'error' });
            })
    }
    const regenerateAudio = (articleId) => {
        setIsProcessing(true)
        regenerateAudioPerPage(articleId, [{'page_num': page.num}])
            .then((res) => {

                if (res && res.data) {
                    updateAudioPaths(res.data)
                }
                setNotification({ show: true, snackbarMessage: t('updatedAudio'), severity: 'success' });
                setIsProcessing(false)

            })
            .catch(e => {
                setNotification({ show: true, snackbarMessage: t('updateError'), severity: 'error' });
                setIsProcessing(false)
            })
    }
      
    const updatePages = () => {
        return updatePagesDataByArticleId(articleId, updatedPages)
            .then(() => {
                const existingPage = updatedPages.find(item => item.num === page.num);

                setPage({
                    ...page,
                    content: existingPage?.content ? existingPage.content : page.content,
                    translated_text: existingPage?.translated_text ? existingPage.translated_text : page.translated_text,
                })
                setUpdatePages([])
                setNotification({ show: true, snackbarMessage: t('updatedPages'), severity: 'success' });
            })
            .catch((error) => {
                setNotification({ show: true, snackbarMessage: t('updateError') , severity: 'error' });
            });
    };
    

    return (
        <div className="digitizationEditorBody">
            <div className="body-component">
                <BodyComponents
                    mediaPath={mediaPath}
                    numPages={numPages}
                    pages={pages}
                    forcePageNumber={forcePageNumber}
                    pageNumber={pageNumber}
                    setForcePageNumber={setForcePageNumber}
                    containerWidth={containerWidth}
                    configWidth={configWidth}
                    handleFullScreen={handleFullScreen}
                    isFullScreen={isFullScreen}
                    setNotification={setNotification}
                    articleId={articleId}
                    zoom={zoom}
                    setZoom={setZoom}
                />

                <DigitizationMarkdownComponent
                    pageNumber={pageNumber}
                    configWidth={configWidth}
                    containerWidth={containerWidth}
                    updateConfigWidth={updateConfigWidth}
                    page={page}
                    numPages={numPages}
                    digitizationId={digitizationId}
                    sourceLanguage={sourceLanguage}
                    targetLanguage={targetLanguage}
                    addOrUpdatePages={addOrUpdatePages}
                    updatedPages={updatedPages}
                    handleSave={updatePages}
                    regenerateBookmarking={regenerateBookmarking}
                    regenerateAudio={regenerateAudio}
                    bookmarkingSelected={bookmarkingSelected}
                    translationSelected={translationSelected}
                    articleId={articleId}
                    isProcessing={isProcessing}
                    fileName={fileName}
                    fetchData={fetchData}
                />
            </div>
        </div>
    )

}


EditorBodyComponent.propTypes = {
    mediaPath: PropTypes.string,
    containerWidth: PropTypes.string,
    configWidth: PropTypes.string,
    numPages: PropTypes.number,
    pageNumber: PropTypes.number,
    articleId: PropTypes.number,
    digitizationId: PropTypes.number,
    forcePageNumber: PropTypes.number,
    setForcePageNumber: PropTypes.func,
    updateConfigWidth: PropTypes.func,
    sourceLanguage: PropTypes.string,
    targetLanguage: PropTypes.string,
    page: PropTypes.object,
    pages: PropTypes.array,
    updatedPages: PropTypes.array,
    setPage: PropTypes.func,
    handleFullScreen: PropTypes.func,
    setNotification: PropTypes.func,
    setUpdatePages: PropTypes.func,
    isFullScreen: PropTypes.bool,
    bookmarkingSelected: PropTypes.bool,
    translationSelected: PropTypes.bool,
    fileName: PropTypes.string,
    fetchData: PropTypes.func
};
export default EditorBodyComponent;